import { Model, modelRegistry } from './Model';
import { Product } from '.';
export class ProductIngredient extends Model {
    static entity = 'product_ingredients';
    id = null;
    product_id = null;
    super_product_id = null;
    quantity = '0.000';
    created_at = null;
    updated_at = null;
    product;
    superProduct;
    static fields() {
        return {
            id: this.attr(null),
            product_id: this.attr(null),
            super_product_id: this.attr(null),
            quantity: this.attr('0.000', value => this.round(value, 3).toFixed(3)),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            product: this.attr(undefined, value => value ? new Product(value) : undefined),
            superProduct: this.attr(undefined, value => value ? new Product(value) : undefined),
        };
    }
    constructor(record) {
        super();
        this.$fill(record);
    }
    getQuantity() {
        return parseFloat(this.quantity);
    }
}
export default ProductIngredient;
modelRegistry.register('ProductIngredient', ProductIngredient);
//# sourceMappingURL=ProductIngredient.js.map